<script setup lang="ts">
import GmailIcon from '~icons/logos/google-icon';
import FacebookIcon from '~icons/logos/facebook';
import SmartPhoneIcon from '~icons/material-symbols-light/smartphone-outline-sharp';

import type { FirstStepProps } from '.';
import type { FunctionalComponent, SVGAttributes } from 'vue';
import type { ButtonVariants } from '~/components/ui/button';

import messages from './FirstStep.stories.json';

const { t } = useI18n({
	useScope: 'local',
	messages
});

defineProps<FirstStepProps>();

const emit = defineEmits<{
	(e: 'update:modelValue' | 'validated', value: string): void;
}>();

const method = defineModel<string>();

interface Button {
	text: string;
	icon: FunctionalComponent<SVGAttributes>;
	method: string;
	variant: ButtonVariants['variant'];
}

const buttons = computed<Button[]>(() => [
	{
		text: t('google'),
		icon: GmailIcon,
		method: 'google',
		variant: 'secondary'
	},
	{
		text: t('facebook'),
		icon: FacebookIcon,
		method: 'facebook',
		variant: 'secondary'
	},
	{
		text: t('phone'),
		icon: SmartPhoneIcon,
		method: 'sms',
		variant: 'primary'
	}
]);

function setMethod(button: Button) {
	method.value = button.method;
	emit('validated', button.method);
}
</script>

<template>
	<section class="flex flex-col gap-3" data-testid="first-step">
		<Button
			v-for="button in buttons"
			:key="`login-form-button:${button.method}`"
			:variant="button.variant"
			size="sm"
			class="h-12 py-2.5"
			data-testid="login-buttons"
			@click="setMethod(button)"
		>
			<component :is="button.icon" class="size-5" />
			{{ button.text }}
		</Button>
	</section>
</template>
